import ProductItem from '../components/product/ProductItem';
import reinitSwymActionButtons from '../helpers/reinitSwymActionButtons';

export default function initProductItemEvents() {
  document.addEventListener('product-item:init', event => {
    const { productItem } = event.detail;
    new ProductItem(productItem);
  });

  /**
   * Bind Swym to a card that draws its own wishlist button without the Shopify card
   * fragment — the SearchSpring PLP renders one from indexed data. `product-item:init`
   * would do this too, but it also constructs a ProductItem, whose swatch handler rewrites
   * the card with `outerHTML` and fights Preact for nodes it owns there.
   */
  document.addEventListener('product-item:swym-init', event => {
    const { productItem } = event.detail || {};
    if (productItem) {
      reinitSwymActionButtons(productItem);
    }
  });
}
